var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rank-info",style:({'backgroundColor': _vm.rankInfo.color})},[_vm._v(_vm._s(_vm.rankInfo.text))])}
var staticRenderFns = []

export { render, staticRenderFns }